import { useContext } from 'react';
import TradeContext from '~/context/common/TradeContext';
import InventoryContext from '~/context/srp/InventoryContext';

export default function useBannerReady() {
  const {
    inventory: { hasEverLoaded: hasInventoryEverLoaded }
  } = useContext(InventoryContext);
  const {
    trades: { hasEverLoaded: hasTradesEverLoaded }
  } = useContext(TradeContext);

  return hasInventoryEverLoaded && hasTradesEverLoaded;
}
